import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import { Box, Grid, TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import axios from 'axios'
import Locale from 'date-fns/locale/sq'
import { saveAs } from 'file-saver'
import 'loaders.css/loaders.css'
import { inject } from 'mobx-react'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card, Col, Row } from 'reactstrap'
import Swal from 'sweetalert2'
import ContentWrapper from '../../Layout/ContentWrapper'
import ResignIntervieModal from './resignInterviewModal'
import { ExitWorkStatusLabels } from '../../../utils/exitWorkStatus'

const LOCATION_OPTIONS = ['Prishtinë HQ', 'Ferizaj', 'Vushtrri', 'Prizren']
const datePickerTextFieldSx = {
  width: '170px',
  '& .MuiInputBase-root': {
    height: '40px',
    px: 0.9,
    '& input': {
      padding: '4px 6px 0 6px'
    }
  },
  '& .MuiInputLabel-root': {
    transform: 'translate(14px, 8px) scale(1)',
    '&.Mui-focused, &.MuiFormLabel-filled': {
      transform: 'translate(14px, -5px) scale(0.75)'
    }
  }
}

var timeout = null
@inject('userStore')
class ExitList extends React.Component {
  constructor() {
    super()
    this.state = {
      getData: [],
      count: 10,
      total: 0,
      page: 0,
      searchText: '',
      projects: [],
      funksionet: [],
      departaments: [],
      projectSelected: '',
      departmentSelected: '',
      functionSelected: '',
      activities: [],
      activitySelected: '',
      activityRender: '',
      projectRender: '',
      departmentRender: '',
      functionRender: '',
      loader: false,
      emailType: 1,
      firstNameType: 1,
      lastNameType: 1,
      positionType: 1,
      projectType: 1,
      activityType: 1,
      exitReasonType: 1,
      exitDateType: 1,
      showDepartment: false,
      showActivity: false,
      languages: [],
      languageSelected: '',
      languageRender: '',
      showLanguage: false,
      showExitWorkStatus: false,
      fromDateValue: '',
      toDateValue: '',
      locationRender: [],
      locationSelected: ''
    }

    this._getExport = this._getExport.bind(this)
    this._getData = this._getData.bind(this)
    this.onFromDateChange = this.onFromDateChange.bind(this)
    this.onToDateChange = this.onToDateChange.bind(this)
  }

  _getData = () => {
    this.axiosCancelSource = axios.CancelToken.source()
    this.setState({ loader: true })

    axios
      .get(`projects`, { cancelToken: this.axiosCancelSource.token })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            projects: response.data.data
          })
        }
      })
      .catch((error) => {})

    axios
      .get(`roles`, { cancelToken: this.axiosCancelSource.token })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            funksionet: response.data.data
          })
        }
      })
      .catch((error) => {})

    axios
      .get(`departments`, { cancelToken: this.axiosCancelSource.token })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            departaments: response.data.data
          })
        }
      })
      .catch((error) => {})

    axios
      .get(`activities`, { cancelToken: this.axiosCancelSource.token })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            activities: response.data.data
          })
        }
      })
      .catch((error) => {})

    axios
      .get(`languages`, { cancelToken: this.axiosCancelSource.token })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            languages: response.data.data
          })
        }
      })
      .catch((error) => {})

    const { page, count } = this.state
    axios
      .get(`exitlist/${count}/${page + 1}`, { cancelToken: this.axiosCancelSource.token })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            loader: false,
            getData: response.data.data.docs,
            total: response.data.data.totalDocs
          })
        }
      })
      .catch((error) => {})
  }

  componentWillUnmount() {
    this.axiosCancelSource.cancel('Component unmounted')
  }

  componentDidMount() {
    this.axiosCancelSource = axios.CancelToken.source()
    this._getData()
  }

  titleCrop(text) {
    var textCrop = text
    var limit = 80
    var trimmedString = textCrop.length > limit ? textCrop.substring(0, limit - 3) + '...' : textCrop
    return trimmedString
  }

  isDateRangeInvalid = (fromDateValue = this.state.fromDateValue, toDateValue = this.state.toDateValue) => {
    if (fromDateValue && toDateValue && moment(fromDateValue).isAfter(moment(toDateValue), 'day')) {
      Swal.fire('', 'Data Prej nuk mund te jete me e madhe se data Deri', 'error')
      return true
    }

    return false
  }

  _getExport() {
    const {
      functionSelected,
      projectSelected,
      departmentSelected,
      activitySelected,
      searchText,
      languageSelected,
      fromDateValue,
      toDateValue,
      locationSelected
    } = this.state
    var params = {}
    if (functionSelected) {
      params.function = functionSelected
    }
    if (projectSelected) {
      params.project = projectSelected
    }
    if (departmentSelected) {
      params.department = departmentSelected
    }
    if (activitySelected) {
      params.activity = activitySelected
    }
    if (searchText) {
      params.search = searchText
    }
    if (languageSelected) {
      params.language = languageSelected
    }
    if (locationSelected) {
      params.office_location = locationSelected
    }

    if (this.isDateRangeInvalid(fromDateValue, toDateValue)) return

    params.fromDate = fromDateValue.length !== 0 ? fromDateValue : undefined
    params.toDate = toDateValue.length !== 0 ? toDateValue : undefined

    axios
      .get('exitList/export', { params, responseType: 'blob' })
      .then((response) => {
        if (response.headers['content-type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          saveAs(response.data, 'exitList.csv')
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
  }

  _getUsers = async (e) => {
    this.setState({
      loader: true
    })
    const {
      count,
      page,
      functionSelected,
      projectSelected,
      departmentSelected,
      activitySelected,
      searchText,
      languageSelected,
      fromDateValue,
      toDateValue,
      locationSelected
    } = this.state
    var params = {}
    params['function'] = functionSelected ? functionSelected : undefined
    params['project'] = projectSelected ? projectSelected : undefined
    params['department[]'] = departmentSelected ? departmentSelected : undefined
    params['languages[]'] = languageSelected ? languageSelected : undefined
    params['activity'] = activitySelected ? activitySelected : undefined
    params.search = searchText ? searchText : undefined
    params['office_location'] = locationSelected ? locationSelected : undefined

    if (this.isDateRangeInvalid(fromDateValue, toDateValue)) {
      this.setState({ loader: false })
      return
    }

    params.fromDate = fromDateValue.length !== 0 ? fromDateValue : undefined
    params.toDate = toDateValue.length !== 0 ? toDateValue : undefined

    if (e) {
      await this.setState({
        searchText: e.target.value
      })
      params.search = this.state.searchText

      window.onkeyup = (e) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          axios
            .get(`exitList/${count}/${page + 1}`, { params })
            .then((response) => {
              if (response.data.success) {
                this.setState({
                  loader: false,
                  getData: response.data.data.docs,
                  total: response.data.data.totalDocs
                })
              }
            })
            .catch((error) => {})
        }, 500)
      }
    } else {
      axios
        .get(`exitList/${count}/${page + 1}`, { params })
        .then((response) => {
          if (response.data.success) {
            this.setState({
              loader: false,
              getData: response.data.data.docs,
              total: response.data.data.totalDocs
            })
          }
        })
        .catch((error) => {})
    }
  }

  async onFromDateChange(date) {
    if (date && typeof date == 'object') {
      await this.setState({ fromDateValue: moment(date).format('YYYY-MM-DD') })
      await this._getUsers()
    } else if (date === '') {
      await this.setState({ fromDateValue: '' })
      await this._getUsers()
    }
  }

  async onToDateChange(date) {
    if (date && typeof date == 'object') {
      await this.setState({ toDateValue: moment(date).format('YYYY-MM-DD') })
      this._getUsers()
    } else if (date === '') {
      await this.setState({ toDateValue: '' })
      this._getUsers()
    }
  }

  clearDateFilters = () => {
    this.setState({ fromDateValue: '', toDateValue: '' }, this._getUsers)
  }

  render() {
    const level = this.props.userStore.userLevel
    const { count, page, searchText, getData, total } = this.state
    const columns = [
      {
        name: 'Email',
        label: 'Email',
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: 'Emri',
        label: 'Emri',
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: 'Mbiemri',
        label: 'Mbiemri',
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: 'Gjuhet',
        label: 'Gjuhet',
        options: {
          filter: true,
          sort: false,
          display: this.state.showLanguage,
          filterList: this.state.languageRender, //Language selected
          filterOptions: {
            names: this.state.languages.map((element) => element.code)
          } //
        }
      },
      {
        name: 'Pozita',
        label: 'Pozita',
        options: {
          filter: true,
          sort: true,
          filterList: this.state.functionRender, //Function selected
          // filterOptions: this.state.funksionet.map(element => element.name) //List of all functions
          filterOptions: {
            names: this.state.funksionet.map((element) => element.name)
          } //
        }
      },
      {
        name: 'Lokacioni',
        label: 'Lokacioni',
        options: {
          filter: true,
          sort: true,
          filterList: this.state.locationRender,
          filterOptions: {
            names: Array.from(new Set([...LOCATION_OPTIONS, ...this.state.getData.map((e) => e.office_location).filter(Boolean)]))
          }
        }
      },
      {
        name: 'Projekti',
        label: 'Projekti',
        options: {
          filter: true,
          sort: true,
          filterList: this.state.projectRender, //Project selected
          // filterOptions: this.state.projects.map(element => element.name) //List of all Projects
          filterOptions: {
            names: this.state.projects.map((element) => element.name)
          } //
        }
      },
      {
        name: 'Departamenti',
        label: 'Departamenti',
        options: {
          filterType: 'checkbox',
          filter: true,
          sort: false,
          display: this.state.showDepartment,
          filterList: this.state.departmentRender, //Department selected
          // filterOptions: this.state.departaments.map(element => element.name) //List of all Departments
          filterOptions: {
            names: this.state.departaments.map((element) => element.name)
          } //
        }
      },
      {
        name: 'Aktiviteti',
        label: 'Aktiviteti',
        options: {
          filter: true,
          sort: true,
          display: this.state.showActivity,
          filterList: this.state.activityRender, //Activity selected
          // filterOptions: this.state.activities.map(element => element.name) //Lisof all activities
          filterOptions: {
            names: this.state.activities.map((element) => element.name)
          } //
        }
      },
      {
        name: 'Arsyeja e daljes',
        label: 'Arsyeja e daljes',
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: 'Data e daljes',
        label: 'Data e daljes',
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: 'Statusi i fundit i punës',
        label: 'Statusi i fundit i punës',
        options: {
          filter: false,
          sort: true,
          display: this.state.showExitWorkStatus
        }
      },
      {
        name: 'Snapshots',
        label: 'Snapshots',
        options: {
          filter: false,
          sort: false
        }
      },
      {
        name: 'Pamje',
        label: 'Pamje',
        options: {
          filter: false,
          sort: false
        }
      }
    ]
    const options = {
      download: false,
      elevation: 0,
      sort: false,
      pagination: true,
      filter: true,
      filterType: 'dropdown',
      responsive: 'scroll',
      viewColumns: true,
      selectableRows: 'none',
      serverSide: true,
      count: total,
      page: this.state.page,
      search: false,
      rowsPerPage: count,
      rowsPerPageOptions: [10, 50, 100, 200],
      textLabels: {
        body: {
          noMatch: 'Nuk ka të dhëna'
        },
        pagination: {
          next: 'Faqja tjeter',
          previous: 'Faqja e meparshme',
          rowsPerPage: 'Rreshta për faqe',
          displayRows: 'të'
        },
        toolbar: {
          search: 'Kërko',
          downloadCsv: 'Shkarko në CSV',
          print: 'Printo',
          viewColumns: 'Shiko kolonat',
          filterTable: 'Tabela e filtrimit'
        },
        filter: {
          all: 'TE GJITHA',
          title: 'FILTRIMET',
          reset: 'RIVENDOS'
        },
        viewColumns: {
          title: 'Shfaq kolonat',
          titleAria: 'Trego/fsheh kolonat e tabelave'
        }
      },
      customToolbar: () => {
        return (
          <Tooltip title={'Shkarko CSV'}>
            <IconButton
              aria-label={'Shkarko CSV'}
              onClick={() => {
                this._getExport()
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        )
      },
      onFilterChange: async (changedColumn, filterList) => {
        switch (changedColumn) {
          case 'Gjuhet':
            await this.setState({
              languageRender: filterList[3]
            })

            this.state.languages.forEach((element) => {
              if (element.code == this.state.languageRender[0]) {
                this.setState({ languageSelected: element._id })
              } else if (this.state.languageRender.length == 0) {
                this.setState({ languageSelected: '' })
              }
            })

            this._getUsers()
            break
          case 'Lokacioni':
            await this.setState({
              locationRender: filterList[5]
            })

            if (this.state.locationRender && this.state.locationRender.length > 0) {
              this.setState({ locationSelected: this.state.locationRender[0] })
            } else {
              this.setState({ locationSelected: '' })
            }

            this._getUsers()
            break
          case 'Pozita':
            await this.setState({
              functionRender: filterList[4]
            })

            this.state.funksionet.forEach((element) => {
              if (element.name == this.state.functionRender[0]) {
                this.setState({ functionSelected: element._id })
              } else if (this.state.functionRender.length == 0) {
                this.setState({ functionSelected: '' })
              }
            })

            this._getUsers()
            break
          case 'Projekti':
            await this.setState({
              projectRender: filterList[6]
            })

            this.state.projects.forEach((element) => {
              if (element.name == this.state.projectRender[0]) {
                this.setState({ projectSelected: element._id })
              } else if (this.state.projectRender.length == 0) {
                this.setState({ projectSelected: '' })
              }
            })

            this._getUsers()
            break
          case 'Departamenti':
            var array = []
            await this.setState({ departmentRender: filterList[7] })
            this.state.departaments.map((department) => {
              filterList[7].forEach(async (element) => {
                if (department.name == element) {
                  array.push(department._id)
                  await this.setState({
                    departmentSelected: array
                  })
                }
              })
            })

            if (filterList[7].length == 0) {
              await this.setState({
                departmentSelected: ''
              })
            }

            this._getUsers()
            break
          case 'Aktiviteti':
            await this.setState({
              activityRender: filterList[8]
            })

            this.state.activities.forEach((element) => {
              if (element.name == this.state.activityRender[0]) {
                this.setState({ activitySelected: element._id })
              } else if (this.state.activityRender.length == 0) {
                this.setState({ activitySelected: '' })
              }
            })

            this._getUsers()
            break
        }
      },
      onTableChange: async (action, tableState) => {
        switch (action) {
          case 'changePage':
            await this.setState({ page: tableState.page })
            this._getUsers()
            break
          case 'resetFilters':
            await this.setState({
              functionRender: '',
              projectRender: '',
              activityRender: '',
              departmentRender: '',
              functionSelected: '',
              projectSelected: '',
              activitySelected: '',
              departmentSelected: '',
              languageRender: '',
              locationRender: [],
              locationSelected: ''
            })
            this._getUsers()
            break
          case 'changeRowsPerPage':
            await this.setState({ count: tableState.rowsPerPage })
            this._getUsers()
            break
          case 'columnViewChange':
            this.setState({
              showLanguage: tableState.columns[3].display == 'true' ? true : false,
              showDepartment: tableState.columns[7].display == 'true' ? true : false,
              showActivity: tableState.columns[8].display == 'true' ? true : false,
              showExitWorkStatus: tableState.columns[11].display == 'true' ? true : false
            })
            break
        }
      }
    }

    const data = this.state.getData.map((element) => {
      return [
        element.email ? element.email : '',
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>{element.first_name ? element.first_name : ''}</span>
          {element.is_active && (
            <span
              style={{
                backgroundColor: '#32cd32',
                color: 'white',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '10px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                boxShadow: '0 2px 4px rgba(50, 205, 50, 0.3)'
              }}
            >
              Active
            </span>
          )}
        </div>,
        element.last_name ? element.last_name : '',
        element.languages && element.languages?.map((lang) => lang?._id?.code).join(','),
        element.snapshot_profile?.function && element.snapshot_profile.function.name,
        element.snapshot_profile?.office_location ? element.snapshot_profile?.office_location : '',
        element.snapshot_profile?.project && element.snapshot_profile.project.name,
        element.department &&
          element.department.map((department, index) => {
            return element.department.length - 1 == index ? department.name : department.name + ', '
          }),
        element.activity && element.activity.name,
        element.snapshot_profile?.exit_reason && element.snapshot_profile.exit_reason != null
          ? element.snapshot_profile?.exit_reason == 'Tjeter...'
            ? element.snapshot_profile?.other_exit_reason != null
              ? this.titleCrop(element.snapshot_profile?.other_exit_reason)
              : this.titleCrop(element.snapshot_profile?.exit_reason)
            : this.titleCrop(element.snapshot_profile?.exit_reason)
          : '-',

        element.snapshot_profile?.exit_date && element.snapshot_profile.exit_date != undefined
          ? moment(element.snapshot_profile?.exit_date).format('DD/MM/YYYY')
          : '',

        element.snapshot_profile?.exit_work_status
          ? ExitWorkStatusLabels[element.snapshot_profile.exit_work_status] || element.snapshot_profile.exit_work_status
          : '-',

        element.has_snapshot ? (
          <Button
            outline
            className='mb-1'
            color='info'
            type='button'
            size='sm'
            onClick={() => {
              window.location.href = `/editUsers/${element._id}?snapshot=${element.snapshot_profile._id}`
            }}
          >
            <i className='fa fa-camera'></i> See Snapshot
          </Button>
        ) : (
          <span>-</span>
        ),
        <Link to={`/editUsers/${element._id}`}>
          <Button outline className='mb-1' color='warning' type='button'>
            <span>Shfaq</span>
          </Button>
        </Link>
      ]
    })
    return (
      <ContentWrapper>
        <div className='content-heading'>
          <div>Lista e daljes</div>
        </div>
        <ResignIntervieModal />
        <Row>
          <Col>
            <Card className={`shadow bg-white ${this.state.loader && 'whirl standard'}`}>
              <MUIDataTable
                ref={(ref) => (this.tableRef = ref)}
                columns={columns}
                options={options}
                data={data}
                title={
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={Locale}>
                    <Grid container alignItems='center' gap={3} sx={{ fieldset: { border: '1px solid' } }}>
                      <Grid item>
                        <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                          <TextField
                            label='Kërko përdoruesin'
                            size='small'
                            value={this.state.searchText}
                            onChange={this._getUsers}
                            InputProps={{
                              sx: {
                                height: '40px',
                                px: 0.9,
                                '& input': {
                                  padding: '4px 6px'
                                }
                              }
                            }}
                            InputLabelProps={{
                              sx: {
                                transform: 'translate(14px, 8px) scale(1)',
                                '&.Mui-focused, &.MuiFormLabel-filled': {
                                  transform: 'translate(14px, -5px) scale(0.75)'
                                }
                              }
                            }}
                          />
                        </Box>
                      </Grid>
                      <Grid container item width='fit-content' gap={1} alignItems='center'>
                        <Grid item>
                          <DatePicker
                            label='Prej:'
                            openTo='year'
                            inputFormat='dd/MM/yyyy'
                            views={['year', 'month', 'day']}
                            value={this.state.fromDateValue ? moment(this.state.fromDateValue).toDate() : null}
                            onAccept={(date) => this.onFromDateChange(date)}
                            renderInput={(params) => <TextField size='small' {...params} sx={datePickerTextFieldSx} />}
                            onChange={() => {}}
                          />
                        </Grid>
                        <Grid item>
                          <DatePicker
                            label='Deri:'
                            openTo='year'
                            inputFormat='dd/MM/yyyy'
                            views={['year', 'month', 'day']}
                            value={this.state.toDateValue ? moment(this.state.toDateValue).toDate() : null}
                            onAccept={(date) => this.onToDateChange(date)}
                            renderInput={(params) => <TextField size='small' {...params} sx={datePickerTextFieldSx} />}
                            onChange={() => {}}
                          />
                        </Grid>
                        {(this.state.fromDateValue || this.state.toDateValue) && (
                          <Grid item>
                            <Button className='btn btn-secondary btn-sm' type='button' onClick={this.clearDateFilters}>
                              Pastro
                            </Button>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </LocalizationProvider>
                }
              />
            </Card>
          </Col>
        </Row>
      </ContentWrapper>
    )
  }
}

export default ExitList
